
<button kendoButton
        [ngClass]="{'val-simple-bouton-desactive': desactive, 'val-simple-bouton-principal': principal}"
        class="val-simple-bouton"
        title="{{libelle}}"
        iconClass="{{iconeClass}}"
        (click)="Click()"
>
{{libelle}}
</button>
